"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tab = _interopRequireDefault(require("../Tab"));

require("../assets/css/font-face.css");

require("./Tabs.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useState = (0, _react.useState)(children[0].props.label),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var getLeftTranslate = function getLeftTranslate() {
    var items = children.map(function (child) {
      return child.props.label;
    });
    return items.indexOf(activeTab) * 100;
  };

  var indicatorStyle = {
    width: "calc(100% / ".concat(children.length, ")"),
    transform: "translateX(".concat(getLeftTranslate(), "%)")
  };
  var contentStyle = {
    transform: "translateX(-".concat(getLeftTranslate(), "%)")
  };
  var wrapperClass = 'tabs';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("div", {
    className: "tabs__list"
  }, _react.default.createElement("ol", null, children.map(function (child) {
    var label = child.props.label;
    return _react.default.createElement(_Tab.default, {
      activeTab: activeTab,
      key: label,
      label: label,
      onClick: function onClick(tab) {
        return setActiveTab(tab);
      }
    });
  })), _react.default.createElement("span", {
    className: "tabs__indicator",
    style: indicatorStyle
  })), _react.default.createElement("div", {
    className: "tabs__content",
    style: contentStyle
  }, children.map(function (child, index) {
    return _react.default.createElement("div", {
      className: "tabs__content-item",
      key: index
    }, child.props.children);
  })));
};

Tabs.propTypes = {
  children: _propTypes.default.instanceOf(Array).isRequired
};
var _default = Tabs;
exports.default = _default;